
import { Button } from "@/components/ui/button";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useProductContext } from "@/context/ProductContext";
import { Plus, RefreshCcw } from "lucide-react";
import { useProducts } from "@/hooks/useProducts";

const ProductHeader = () => {
  const { setIsAddSheetOpen } = useProductContext();
  const { refreshProducts } = useProducts();

  return (
    <CardHeader className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-2 sm:space-y-0">
      <div>
        <CardTitle>Gestion des Produits</CardTitle>
        <CardDescription>
          Gérez vos licences de produits et leurs dates d'expiration
        </CardDescription>
      </div>
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          size="icon"
          onClick={refreshProducts}
          title="Rafraîchir la liste"
        >
          <RefreshCcw className="h-4 w-4" />
        </Button>
        <Button 
          onClick={() => setIsAddSheetOpen(true)}
          size="sm"
          className="flex items-center"
        >
          <Plus className="h-4 w-4 mr-1" />
          Ajouter
        </Button>
      </div>
    </CardHeader>
  );
};

export default ProductHeader;
